import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  StepType,
  MembershipOption,
  RegistrationStepService,
  ChildRegistrationModel,
  MembershipOptionsRegistrationViewModel,
  RegistrationStepQuery
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'membershipOption'
})
export class MembershipOptionPipe implements PipeTransform {

  transform(membershipId: number, membershipOptions: MembershipOption[]): unknown {
    return membershipOptions.find(option => option.MembershipOptionId === membershipId);
  }

}

@Component({
  selector: 'fgbcl-registration-membership-options',
  templateUrl: './registration-membership-options.component.html',
  styleUrls: ['./registration-membership-options.component.scss'],
})
export class RegistrationMembershipOptionsComponent implements OnInit {

  childrenForm: UntypedFormGroup;
  membershipOptions: MembershipOption[];
  children: ChildRegistrationModel[];
  selectedOption: MembershipOption | undefined;
  showMembershipOptions: boolean = false;
  selectedChild: FormGroup;
  readonly stepType = StepType.MembershipOption;

  constructor(
    private registrationStepService: RegistrationStepService, 
    private registrationQuery: RegistrationStepQuery,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder) 
    {}


  ngOnInit() {
    this.registrationStepService
      .fetchRegistrationStepForCurrentWizard(this.stepType, true)
      .pipe(
        tap((addChildStepData) => {
          let viewModel = addChildStepData.Data as MembershipOptionsRegistrationViewModel;

          // TODO: Remove this when the api is returning the correct data.
          // Temporary get the children data from store as the api is not returning the correct data.
          // this.children = viewModel.Children;
          const childStore = this.registrationQuery.getEntity(this.stepType)?.Data;
          const children = viewModel.Children.filter(child => !childStore.includes(child.RegistrationId));
          const getChildData = (registrationId: number) => childStore.find((child: any) => child.RegistrationId === registrationId);
          this.children = children.map(child => ({ ...child, MembershipOptionId: getChildData(child.RegistrationId)?.MembershipOptionId })) || [];
          this.membershipOptions = viewModel.MembershipOptions;
          // this._setMembershipOptions(viewModel.MembershipOptions, addChildStepData);
          this.childrenForm = this.fb.group({
            children : this.fb.array(this.children.map(child => this.childForm(child)))
          });

        })
      )
      .toPromise();
  }

  childForm(child: ChildRegistrationModel){
    const value = child.MembershipOptionId || (this.membershipOptions?.length === 1 ? this.membershipOptions[0].MembershipOptionId : '');
    const form = this.fb.group({
      Firstname: [ child.Firstname || '' ],
      Lastname: [ child.Lastname || '' ],
      DateOfBirth: [ child.DateOfBirth || '' ],
      RegistrationId: [ child.RegistrationId || 0 ],
      MembershipOptionId: [ value, Validators.required ]
    });

    if(child.IsAlreadyPaid){
      form.disable();
    }

    return form;
  }

  submitStep() {
    this.childrenForm.markAllAsTouched();

    if( this.childrenForm.valid ){
      this.children = this.children.map(child => ({ ...child, ...this.getChildData(child.RegistrationId)  }));
      this.registrationStepService.submitRegistrationStepData(this.stepType, this.children).toPromise();
    }
  }

  showMembershipOption(form: FormGroup){
    this.showMembershipOptions = true;
    this.selectedChild = form;
  }

  selectMembership(membershipId: number): void{
    this.selectedChild.get('MembershipOptionId')?.setValue(membershipId);
    this.showMembershipOptions = false;
  }

  getChildData(registrationId: number){
    return this.childrenForm.value.children.find((child: any) => child.RegistrationId === registrationId);
  }

  openMembershipInfo(membershipInfo: any, data: any): Promise<any>{
    this.selectedOption = data;
    return this.modalService.open(membershipInfo, {
      windowClass: 'registration-membership-modal'
    }).result;
  }

  closeModal(): void{
    this.modalService.dismissAll();
  }

  get hasSelectedMembership(): boolean {
    return this.childrenForm?.value.children.every((child: any) => child.MembershipOptionId !== '');
  }

  // _setMembershipOptions(options: MembershipOption[], existingStepData: RegistrationStep) {
  //   // Check if the step has been completed already.
  //   let existingChildren: ChildRegistrationModel[];
  //   if (existingStepData && existingStepData.Data) {
  //     this.loggingService.info('Using existing step data', existingStepData);
  //     existingChildren = [ ...existingStepData.Data as ChildRegistrationModel[] ] ;
  //   }


  //   // Set membership option
  //   this.children.forEach((child) => {
  //     let existingChild: ChildRegistrationModel | undefined;
  //     if (existingChildren && existingChildren.length > 1) {
  //       existingChild = existingChildren.find((x) => x.Firstname === child.Firstname && x.Lastname === child.Lastname);
  //     } else {
  //       existingChild = existingChildren[0];
  //     }

  //     if (existingChild && existingChild.MembershipOptionId) {
  //       // this step has already been completed for this child.
  //       child.MembershipOptionId = existingChild.MembershipOptionId;
  //     } else {
  //       // this step has not yet been completed for this child, take default membership option.
  //       // If there are paid options take the first as default.
  //       child.MembershipOptionId = options[0].MembershipOptionId;
  //     }
  //   });
  // }
}
